export enum DocumentTagEnum {
    CustomerFullName = 1,
    BuyerLegalName = 2,
    BuyerLegalContactAddress = 3,
    BuyerStateOfRegistration = 4,
    BuyerLegalContactName = 5,
    BuyerDbaFullName = 6,
    BuyerDbaNickName = 7,
    BuyerLegalContactTitle = 8,
    BuyerCityOfRegistration = 9,
    BuyerAddressOfRegistration = 10,
    BuyerZipCodeOfRegistration = 11,
    OppId = 12,
    EffectiveData = 13,
    SellerLegalName = 14,
    SellerLegalContactName = 15,
    SellerLegalContactTitle = 16,
    SellerLegalContactStreetAddress = 17,
    SellerLegalContactCity = 18,
    SellerLegalContactState = 19,
    SellerLegalContactZip = 20,
    PracticeOwner = 21,
    PracticeOwnerTitle = 22,
    DataNdaPracticesInfo = 23,
    EngagementPracticesNames = 24,
    EngagementPracticesLegalNames = 25,
    EngagementPracticesStatesOfRegistration = 26,
    EngagementPracticesTypesOfLegalEntity = 27,
    DataNdaDpmNonSolicitationDuration = 28,
    DataNdaOsNonSolicitationDuration = 29,
    DataNdaNonDisclosureDuration = 30,
    EngagementStateOfLegalEntityRegistration = 31,
    BuyerTypeOfLegalEntity = 32,
}
